/**
 * 免费试用对话框选项
 */
export interface FreeTrailDialogOptions {
    /**
     * 对话框标题
     * @default t('freeTrail.titleWithEmoji')
     */
    title?: string;

    /**
     * 提交按钮文本
     * @default t('freeTrail.experienceNow')
     */
    submitText?: string;
}

export const FreeTrailDialogService = Symbol('FreeTrailDialogService');

/**
 * 免费试用对话框服务
 * @description 用于管理免费试用对话框的显示，支持只显示一次的功能
 */
export interface FreeTrailDialogService {
    /**
     * 显示对话框
     * @param options - 对话框选项
     * @returns Promise<boolean> - true: 用户确认, false: 用户取消
     */
    show(options?: FreeTrailDialogOptions): Promise<boolean>;

    /**
     * 只显示一次对话框，如果已经显示过则不再显示
     * @param options - 对话框选项
     * @returns Promise<boolean> - true: 用户确认, false: 用户取消或已显示过
     */
    showOnce(options?: FreeTrailDialogOptions): Promise<boolean>;

    /**
     * 重置显示状态，下次调用 showOnce 时会再次显示
     */
    reset(): void;

    /**
     * 检查是否已经显示过
     * @returns boolean - true: 已显示过, false: 未显示过
     */
    hasShown(): boolean;

    /**
     * 激活 Pro 套餐
     * @description 调用 API 激活 Pro 套餐，成功后清除缓存并重新加载页面
     */
    activateProPkg(): Promise<void>;
}
